import { createContext } from "react";

const ListContext = createContext({
  insuranceList: [],
  reasonList: [],
  serviceList: [],
  dentistList: [],
  staffList: [],
});

export default ListContext;
